interface FaProps {
  icon: string;
  className?: string;
  [key: string | number | symbol]: unknown;
}

export default function Fa({ icon, className, ...props }: FaProps): JSX.Element | null {
  return icon ? <i className={`fa fa-${icon} ${className || ''}`} {...props} /> : null;
}

const defaultProps: Pick<FaProps, 'className'> = {
  className: undefined,
};

Fa.defaultProps = defaultProps;
